import React from "react";
import {
  CreateStaffFormProps,
  CreateStaffFormSubmit,
} from "../../declarations/form";
import AppCopy from "../../copy/AppCopy";
import { Formik } from "formik";
import { CreateStaffValidation } from "../../validations/schemes";

function CreateStaffForm({ onSubmit }: CreateStaffFormProps) {
  const handleSubmit = (data: CreateStaffFormSubmit) => {
    onSubmit(data);
  };

  const {
    emailPlaceholder,
    passwordPlaceholder,
    namePlaceholder,
    phonePlaceholder,
    registerButtonText,
  } = AppCopy.createStaffPage;

  return (
    <div className={Classname.container}>
      <Formik
        initialValues={{ email: "", password: "", phone: "", name: "" }}
        validationSchema={CreateStaffValidation}
        onSubmit={(values, action) => {
          handleSubmit(values);
        }}
      >
        {({ handleChange, handleSubmit, values, errors, touched }) => (
          <form className={Classname.form} onSubmit={handleSubmit}>
            <input
              type="text"
              autoComplete="name"
              value={values.name}
              placeholder={namePlaceholder}
              onChange={handleChange("name")}
              className={Classname.input}
            />
            {errors.name && touched.name && (
              <span className={Classname.error}>{errors.name}</span>
            )}
            <input
              type="email"
              autoComplete="email"
              value={values.email}
              placeholder={emailPlaceholder}
              onChange={handleChange("email")}
              className={Classname.input}
            />
            {errors.email && touched.email && (
              <span className={Classname.error}>{errors.email}</span>
            )}
            <input
              type="tel"
              autoComplete="tel"
              value={values.phone}
              placeholder={phonePlaceholder}
              onChange={handleChange("phone")}
              maxLength={10}
              className={Classname.input}
            />
            {errors.phone && touched.phone && (
              <span className={Classname.error}>{errors.phone}</span>
            )}
            <input
              type="password"
              autoComplete="new-password"
              value={values.password}
              placeholder={passwordPlaceholder}
              onChange={handleChange("password")}
              className={Classname.input}
            />
            {errors.password && touched.password && (
              <span className={Classname.error}>{errors.password}</span>
            )}
            <div className={Classname.filler}></div>
            <div className={Classname.buttonContainer}>
              <button
                className={Classname.button}
                type="submit"
              >
                {registerButtonText}
              </button>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default CreateStaffForm;

const Classname = {
  container: "flex flex-1 flex-col",
  form: "flex flex-1 flex-col",
  label: "font-medium text-white mt-2",
  input:
    "my-2 h-12 w-full rounded-lg border border-slate-300 bg-white px-3 text-sm font-normal text-primaryText",
  buttonContainer: "flex w-full items-center justify-center",
  button:
    "mt-4 h-12 w-full cursor-pointer rounded-lg bg-primary text-sm font-bold text-white hover:opacity-90",
  error: "text-xs text-error",
  filler: "flex flex-1",
};
